exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\r\n * @Description: logo 基础样式\r\n * @Author: yy\r\n * @LastEditors: yy\r\n * @Date: 2019-05-08 14:11:40\r\n * @LastEditTime: 2019-05-08 14:29:14\r\n */\r\n\r\n.Logo-root-uDRdE {\r\n  display: inline-block;\r\n}\r\n\r\n.Logo-root-uDRdE img {\r\n  width: 100%;\r\n}", "", {"version":3,"sources":["E:/dbProject/dbrank_b/src/components/Logo/Logo.css"],"names":[],"mappings":"AAAA;;;;;;GAMG;;AAEH;EACE,sBAAsB;CACvB;;AACD;EACE,YAAY;CACb","file":"Logo.css","sourcesContent":["/*\r\n * @Description: logo 基础样式\r\n * @Author: yy\r\n * @LastEditors: yy\r\n * @Date: 2019-05-08 14:11:40\r\n * @LastEditTime: 2019-05-08 14:29:14\r\n */\r\n\r\n.root {\r\n  display: inline-block;\r\n}\r\n.root img {\r\n  width: 100%;\r\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"root": "Logo-root-uDRdE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[name]-[local]-[hash:base64:5]","minimize":false,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Logo/Logo.css
// module id = 1700
// module chunks = 1